'use client';
import { FC } from 'react';

import Text from '@/components/Text';
import Button from '@/components/Button';
import { ModalPropTypes } from '@/layouts/Modal';
import useToggle from '@/hooks/useToggle';
import { useUser } from '@/context/userContext';
import { http, logger } from '@/config';
import { ADDRESS_ENDPOINT } from '@/config/endpoints';

interface DeleteModalPropTypes extends ModalPropTypes {
  id: number | undefined;
}

const DeleteAddress: FC<DeleteModalPropTypes> = ({ id, onClose }) => {
  const { value: isSubmitting, toggleValue: setIsSubmitting } =
    useToggle(false);
  const { userDetails, updateUserDetails } = useUser();

  async function deleteAddress() {
    setIsSubmitting(true);
    try {
      await http.delete(`${ADDRESS_ENDPOINT}/${id}`);
      updateUserDetails();
      onClose();
    } catch (error) {
      logger.log('Error deleting address', address, error);
    }
    setIsSubmitting(false);
  }

  function getAddress() {
    const address = userDetails?.addresses.find(
      (address: { id: any }) => address.id === Number(id)
    );
    if (address) {
      return address;
    }
    return null;
  }

  const address = getAddress();
  const onDeleteAddressClose = () => onClose();

  return (
    <>
      <Text className='p-0'>
        Are you sure you want to delete this address with name{' '}
        {address?.firstname} {address?.lastname} ?
      </Text>
      <div className='flex w-full flex-col items-center gap-y-2'>
        <Button
          type='button'
          label={isSubmitting ? 'Please wait....' : 'Yes, Delete'}
          disabled={isSubmitting}
          onClick={() => deleteAddress()}
          className='py-[0.94rem]'
        />
        <Button
          label='No, Keep it'
          onClick={onDeleteAddressClose}
          variant='link'
          className='py-[0.94rem]'
        />
      </div>
    </>
  );
};

export default DeleteAddress;
